import { render } from "./GlobalCodesTable.vue?vue&type=template&id=7d2921d8"
import script from "./GlobalCodesTable.vue?vue&type=script&lang=js"
export * from "./GlobalCodesTable.vue?vue&type=script&lang=js"

import "./GlobalCodesTable.vue?vue&type=style&index=0&id=7d2921d8&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__